<script>
//ii
import Vue from 'vue';
import Navigation from './components/Navigation';
import { mapState } from 'vuex';
import Fragment from 'vue-fragment';
import Intercom from './Intercom.vue';
import Loader from './components/Loader.vue';
import userflow from 'userflow.js'
import { auth } from './firebase';
import { AUTH_ROUTES } from './router';
import UAParser from 'ua-parser-js';

Vue.use(Fragment.Plugin);
export default {
	components: { Navigation, Intercom, Loader },
	data() {
		return {
			userflowInitialized: false
		}
	},
	computed: {
		...mapState(['user','currentRoleLevel','currentAgreementRoleLevelName','customerDetails','sessionResolved','signingUp']),
		resolvingSession() {
			if (this.signingUp) {
				return true;
			}
			if (AUTH_ROUTES.includes(this.$route.name)) {
				return false;
			}
			return !!(this.user && this.user.uid) && !this.sessionResolved;
		}
	},
	methods: {
		initializeChatBot(){
			this.$root.$emit('appendIntercomScript');
		},
		setInitialDataOnLoad(){
			this.$store.dispatch('getAllRoleLevels')
		},
		updateUserflow() {
			const user = this.user;
			if (user && user.uid) {
				if (!this.userflowInitialized) {
					userflow.init(process.env.VUE_APP_USERFLOW_TOKEN);
					this.userflowInitialized = true;
				}

				try {
					const deviceDetails = new UAParser();

					const identifyPayload = {
					UID: user.uid,
					roleLevel: this.currentRoleLevel?.roleName,
					roleLevelPerAgreement: this.currentAgreementRoleLevelName,
					isSharedUser: this.customerDetails?.isSharedUser || false,
					signed_up_at: auth.currentUser.metadata?.creationTime 
						? new Date(auth.currentUser.metadata.creationTime).toISOString() 
						: undefined,
					...(this.customerDetails?.email && { email: this.customerDetails.email }),
					...(this.customerDetails?.displayName && { displayName: this.customerDetails.displayName }),
					...(this.customerDetails?.displayName || this.customerDetails?.lastName 
						? { name: `${this.customerDetails.displayName || ""} ${this.customerDetails.lastName || ""}`.trim() } 
						: {}),
					browser_name: deviceDetails?.getBrowser().name,
					os_name: deviceDetails?.getOS().name,
					};

					userflow.identify(user.uid, identifyPayload);
				} catch (error) {
					console.error("Error identifying user in Userflow:", error);
				}
			}
		},
        // handleLogoutEvent(event) {
        //     if (event.key === 'logout') {
        //         this.$router.push({ path: '/auth' });
        //         location.reload();
		// 	}
		// }
	},
	mounted(){
		this.initializeChatBot()
		this.setInitialDataOnLoad();
		// window.addEventListener('storage', this.handleLogoutEvent);

		const isEdge = /Edg\//.test(navigator.userAgent); // Detects Chromium-based Edge
        if (isEdge) {
            document.body.classList.add('is-edge');
            const style = document.createElement('style');
            style.textContent = `
            body.is-edge {
                overflow: hidden;
                position: fixed;
                width: 100%;
                height: 100%;
            }

            body.is-edge .home-wrapper > .card-body {
                max-height: 70dvh !important;
                overflow: auto !important;
                position: relative;
            }
            
            body.is-edge .b-table-sticky-header {
                max-height: 400px !important;
                overflow-y: auto !important;
            }
            `;
            document.head.appendChild(style);
        }
	},
    // beforeDestroy() {
    //     window.removeEventListener('storage', this.handleLogoutEvent);
    // }
	watch: {
		user: {
			handler(newUser) {
				this.updateUserflow();
			},
			immediate: true
		},
		currentRoleLevel: {
			handler() {
				this.updateUserflow();
			},
			immediate: true
		},
		currentAgreementRoleLevelName: {
			handler() {
				this.updateUserflow();
			}
		},
		customerDetails: {
            handler() {
                this.updateUserflow();
            }
        }
	},
};
</script>

<template>
	<div id="app">
		<intercom/>
		<navigation :user="user" />
		<!-- <div>This is development environment</div> -->
		<loader v-if="resolvingSession" />
		<router-view v-else />
	</div>
</template>

<style>
#app .form-group {
	margin-bottom: unset;
}

.app-input-group .input {
	margin: 0.1em;
}

.is-edge .side-bar {
  position: relative !important;
  max-height: 100vh;
  overflow: hidden;
}

.is-edge #menu {
  overflow: hidden;
}

#nav-user:focus-visible,
#nav-user:focus,
#nav-user:focus-within {
    outline: none
}

.custom-scroll,
.nav-topics {
  overflow-y: auto;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
.intercom-lightweight-app-launcher{
	bottom: 4.5rem !important;
}

@media (max-width: 768px) {
  .userflowjs-resource-center-frame-wrapper {
    position: relative;
    bottom: 60px;
  }
}
</style>
